import { useEffect, useState } from "react";
import {
  getAuditLogs,
  rehydrateAuditLogs,
  subscribeAuditLogs,
  type AuditLogRecord,
} from "../lib/auditLogStore";

export function useAuditLogs() {
  const [logs, setLogs] = useState<AuditLogRecord[]>(() => getAuditLogs());

  useEffect(() => {
    void rehydrateAuditLogs();
    const unsubscribe = subscribeAuditLogs(() => setLogs(getAuditLogs()));
    setLogs(getAuditLogs());
    return () => unsubscribe();
  }, []);

  return { logs, refreshLogs: rehydrateAuditLogs };
}
